import { combineReducers } from '@reduxjs/toolkit'

import purchases from './purchasesSlice'
import storeOrders from './storeOrdersSlice'
import orders from './ordersSlice'

const reducer = combineReducers({
    purchases,
    storeOrders,
    orders,
})

export default reducer
